/**
 * One-time links carry their token in the URL fragment (never sent to the server, kept out of logs):
 *   /#/virkja/<token>    invite or password-reset link of an existing member (AcceptTokenScreen)
 *   /#/skraning/<token>  invite link by voice: the new member signs up (SignupScreen)
 */
export interface LinkHash {
  kind: 'token' | 'signup';
  token: string;
}

export function parseLinkHash(hash: string): LinkHash | null {
  const m = /^#\/(virkja|skraning)\/([A-Za-z0-9_-]{20,100})$/.exec(hash);
  return m ? { kind: m[1] === 'skraning' ? 'signup' : 'token', token: m[2]! } : null;
}
